export default __webpack_public_path__ + "static/media/COVER.50c63d09.png";